import { render, staticRenderFns } from "./Home8.vue?vue&type=template&id=27cb7b6a&scoped=true&"
import script from "./Home8.vue?vue&type=script&lang=js&"
export * from "./Home8.vue?vue&type=script&lang=js&"
import style0 from "./Home8.vue?vue&type=style&index=0&id=27cb7b6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cb7b6a",
  null
  
)

export default component.exports